import { isCorporateLoggedIn } from 'data/auth/selectors'
import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route, RouteProps } from 'react-router-dom'

import { LOGIN_PATH } from '../../data/auth/utils'

export type PrivateRouteProps = RouteProps

export function PrivateRoute(routeProps: PrivateRouteProps) {
  const canAccess = useSelector(isCorporateLoggedIn)

  if (!canAccess) {
    return <Redirect to={{ pathname: LOGIN_PATH, state: { from: routeProps.location } }} />
  }
  return <Route {...routeProps} />
}
